import { actionType } from "../actions/bybetjentgrupperAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];
const bybetjentGrupperReducer = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, actionType);

export default bybetjentGrupperReducer;
